module.exports = __webpack_public_path__ + "img/beauty_ai_retouch.89c9e0a.png";